 <div [formGroup]="generalInformationFormGroup">
    <h2 class="page-header" id="general">General Information <small class="text-danger">Required</small></h2>
    <hr />
    <div class="mb-3 row" *ngIf="merchantId">
        <label for="merchantProfile" class="col-4 col-form-label text-end">{{isCashnet ? 'Location' : 'Merchant'}} ID</label>
        <div class="col">
            <p class="form-control-plaintext">{{merchantId}}</p>
        </div>
    </div>
    <div class="mb-3 row">
        <label for="merchantProfile" class="col-4 col-form-label text-end">Merchant Profile</label>
        <div class="col">
            <select class="form-select" id="merchantProfile" formControlName="merchantProfileId" [ngClass]="{ 'is-invalid': merchantProfileId.errors && showErrors }">
                <option *ngFor="let merchantProfile of merchantProfiles" [ngValue]="merchantProfile.id">{{merchantProfile.name}}</option>
            </select>
            <div *ngIf="merchantProfileId.invalid && showErrors" class="text-danger">
                <small *ngIf="merchantProfileId.errors.required">Merchant Profile is required</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row">
        <label for="preferredMerchantName" class="col-4 col-form-label text-end">Preferred {{isCashnet ? 'Storefront' : 'Merchant'}} Name</label>
        <div class="col">
            <input type="text" class="form-control" id="preferredMerchantName" formControlName="preferredMerchantName" [ngClass]="{ 'is-invalid': preferredMerchantName.errors && showErrors }" maxlength="25">
            <small id="preferredMerchantNameHelp" class="form-text">Max of 25 characters.</small>
            <div *ngIf="preferredMerchantName.invalid && showErrors" class="text-danger">
                <small *ngIf="preferredMerchantName.errors.required">Preferred Merchant Name is required</small>
                <small *ngIf="preferredMerchantName.errors.notUnique">Preferred Merchant Name must be unique</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row" *ngIf="!isCashnet">
        <label for="customerServicePhoneNumber" class="col-sm-4 col-form-label text-end">Customer Service Number</label>
        <div class="col">
            <div class="input-group">
                <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'phone']"></fa-icon>
                </span>
                <input type="text" class="form-control" id="customerServicePhoneNumber" formControlName="customerServicePhoneNumber" [ngClass]="{ 'is-invalid': customerServicePhoneNumber.errors && showErrors }" appPhoneMask>
            </div>
            <div *ngIf="customerServicePhoneNumber.invalid && showErrors" class="text-danger">
                <small *ngIf="customerServicePhoneNumber.errors.required">Fax Number is required</small>
                <small *ngIf="customerServicePhoneNumber.errors.pattern">Fax Number is not a valid fax number</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row">
        <label for="productServiceSold" class="col-4 col-form-label text-end">Product or Service Being Sold</label>
        <div class="col">
            <textarea class="form-control" id="productServiceSold" formControlName="productServiceSold" [ngClass]="{ 'is-invalid': productServiceSold.errors && showErrors }" maxlength="250"></textarea>
            <div *ngIf="productServiceSold.invalid && showErrors" class="text-danger">
                <small *ngIf="productServiceSold.errors.required">Product or Service Being Sold is required</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row">
        <label for="acceptHSACreditCards" class="col-4 text-end">Will you accept HSA credit cards for payment?</label>
        <div class="col">
            <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="acceptHSACreditCards" id="acceptHSACreditCardsYes" [value]="true" [ngClass]="{ 'is-invalid': acceptHSACreditCards.errors && showErrors }">
                <label class="form-check-label" for="acceptHSACreditCardsYes">
                    Yes
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="acceptHSACreditCards" id="acceptHSACreditCardsNo" [value]="false" [ngClass]="{ 'is-invalid': acceptHSACreditCards.errors && showErrors }">
                <label class="form-check-label" for="acceptHSACreditCardsNo">
                    No
                </label>
            </div>
            <div *ngIf="acceptHSACreditCards.invalid && showErrors" class="text-danger">
                <small *ngIf="acceptHSACreditCards.errors.required">Will you accept HSA credit cards for payment is required</small>
            </div>
        </div>
    </div>
</div>
